import { RemoteManagedImageUtil } from 'sparkello-core';
import { auth, firestore } from '@/firebaseConfig';

export class WebManagedImageUtil extends RemoteManagedImageUtil<typeof auth, typeof firestore> {
  constructor() {
    super(auth, firestore);
    return this;
  }

  private static singleton;

  public static get instance() {
    if (!WebManagedImageUtil.singleton) {
      WebManagedImageUtil.singleton = new WebManagedImageUtil();
    }
    return WebManagedImageUtil.singleton;
  }
}


